import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { sanitizeInput } from "./sanitize";

dayjs.locale("pt-br");
dayjs.extend(timezone);
dayjs.extend(utc);

export const REFERRAL_CODE_STORAGE_KEY = "referralcode";
export const REFERRAL_CODE_EXPIRY_KEY = "referralcodeDayRemove";

export const clearReferralCodeStorage = () => {
  localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
  localStorage.removeItem(REFERRAL_CODE_EXPIRY_KEY);
};

const updateReferralCodeFromUrl = (referralcodeFromUrl) => {
  const sanitizedReferralcode = sanitizeInput(referralcodeFromUrl);
  localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, sanitizedReferralcode);
  localStorage.setItem(
    REFERRAL_CODE_EXPIRY_KEY,
    dayjs().add(7, "day").toISOString(),
  );
};

/**
 * Usa referralcode só quando presente na URL.
 * Sem parâmetro na URL, limpa storage e store (não reutiliza sessão anterior).
 */
export const resolveReferralCodeFromUrl = (
  search = window.location.search,
) => {
  const referralcodeFromUrl = sanitizeInput(
    new URLSearchParams(search).get("referralcode"),
  );

  if (referralcodeFromUrl && referralcodeFromUrl !== "null") {
    updateReferralCodeFromUrl(referralcodeFromUrl);
    return referralcodeFromUrl;
  }

  clearReferralCodeStorage();
  return "";
};

setInterval(() => {
  const referralcodeDayRemove = localStorage.getItem(REFERRAL_CODE_EXPIRY_KEY);
  if (referralcodeDayRemove) {
    const dayRemove = dayjs(referralcodeDayRemove);
    if (dayRemove.isBefore(dayjs())) {
      clearReferralCodeStorage();
    }
  }
}, 1000);

export default updateReferralCodeFromUrl;
